import { render, staticRenderFns } from "./GithubEvent.vue?vue&type=template&id=1cb181e6&"
import script from "./GithubEvent.vue?vue&type=script&lang=js&"
export * from "./GithubEvent.vue?vue&type=script&lang=js&"
import style0 from "./GithubEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports